import { OnboardingApiClient } from '@fourthwall/services/dist/OnboardingApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useChecklistActionVisibilityMutation = createMutationHook(
  OnboardingApiClient.setChecklistActionVisibility,
  {
    mutationKey: ['checklistActionVisibility'],
  },
)
